/** Length of the passwords the platform suggests for devices. */
export const DEVICE_PASSWORD_LENGTH = 10;

// Letters and digits only: device web pages and RTSP URLs mishandle symbols.
// Look-alikes (I, l, 1, O, 0) are left out because installers type the
// password into the device by hand.
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWER = 'abcdefghijkmnopqrstuvwxyz';
const DIGITS = '23456789';
const ALL = UPPER + LOWER + DIGITS;

/** A uniformly random index below n, from the platform's secure generator. */
function randomBelow(n: number): number {
  // Rejection sampling avoids the modulo bias.
  const limit = Math.floor(0x1_0000_0000 / n) * n;
  const buf = new Uint32Array(1);
  for (;;) {
    crypto.getRandomValues(buf);
    const v = buf[0] ?? 0;
    if (v < limit) return v % n;
  }
}

const pick = (set: string) => set.charAt(randomBelow(set.length));

/**
 * A random device password with at least one upper-case letter, one
 * lower-case letter and one digit, as most DVR/NVR/camera firmwares require.
 */
export function generateDevicePassword(length = DEVICE_PASSWORD_LENGTH): string {
  const chars = [pick(UPPER), pick(LOWER), pick(DIGITS)];
  while (chars.length < length) chars.push(pick(ALL));
  // Fisher–Yates, so the guaranteed classes are not always in front.
  for (let i = chars.length - 1; i > 0; i--) {
    const j = randomBelow(i + 1);
    [chars[i], chars[j]] = [chars[j] ?? '', chars[i] ?? ''];
  }
  return chars.join('');
}
